import { DeleteIcon, EditIcon } from "assets/icons";
import { Icon } from "ui";

import { AttributeValueProps } from "./AttributeValue.types";

import styles from "./AttributeValue.module.scss";

const AttributeValue = ({
  title,
  onEdit,
  onDelete,
  isDeleteDisabled = false
}: AttributeValueProps) => {
  return (
    <div className={styles["attribute-value"]}>
      <div className={styles["attribute-value__title"]}>{title}</div>
      <div className={styles["attribute-value__actions"]}>
        <Icon
          as={EditIcon}
          type="button"
          boxSize={16}
          color="#FB3973"
          onClick={onEdit}
        />
        <Icon
          as={DeleteIcon}
          type="button"
          boxSize={18}
          color="#FB3973"
          onClick={onDelete}
          isDisabled={isDeleteDisabled}
        />
      </div>
    </div>
  );
};

export default AttributeValue;
